<template>
    <div class="col">

        <div id="main"
             class="col-main">

            <section class="news-container">

                <div v-for="(article, index) in lists"
                     v-bind:key="index"
                     class="news-post row no-gutters row-main justify-content-center">
                    <div class="col-12 col-lg-10 bg-white">
                        <div class="row no-gutters justify-content-center">
                            <div class="news-post-header col-12 col-lg-9">
                                <h2 class="news-title">{{article.title}}</h2>
                                <h6 class="news-date">
                                    <i class="material-icons icon-4">schedule</i> <span>{{article.readableDate}}</span>
                                </h6>
                            </div>

                            <div class="news-post-body col-12 col-lg-9">
                                <!-- Text -->
                                <p class="h5 news-blurb">{{article.snippet}}</p>
                            </div>

                            <div class="news-post-footer col-12 col-lg-9">
                                <div class="row justify-content-between align-items-center">
                                    <div class="col-auto ">
                                        <a v-bind:href="'#/news/article?id=' + article._id"
                                           class="btn-more btn-has-icon-left"><i class="material-icons">arrow_forward</i>Read
                                                                                                                         more</a>
                                    </div>
                                    <div class="col-auto">
                                        <span v-if="article.section === 'Adults' && siteArea === 'all'"
                                              class="news-tag"><i class="material-icons">bookmark</i> Adults</span>
                                        <span v-if="article.section === 'Juniors' && siteArea === 'all'"
                                              class="news-tag"><i class="material-icons">bookmark</i> Juniors</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <!-- Pagination -->
            <div class="mt-3">
                <b-pagination v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                              align="center"
                              size="lg"/>
            </div>

        </div>

    </div>
</template>
<script>
    import {fetchNews} from "@/services/api";

    export default {
        data() {
            return {
                siteArea: null,
                perPage: 3,
                currentPage: 1,
                news: {
                    all: [],
                    adults: [],
                    juniors: []
                },
            }
        },
        created() {
            if (this.$route.query.team) this.siteArea = this.$route.query.team;
            else this.siteArea = 'all';

            this.fetchList();
        },
        computed: {
            lists() {
                const items = this.news[this.siteArea];
                // Return just page of items needed
                return items.slice(
                    (this.currentPage - 1) * this.perPage,
                    this.currentPage * this.perPage
                )
            },
            totalRows() {
                return this.news[this.siteArea].length
            }
        },
        methods: {
            fetchList() {
                fetchNews()
                    .then(response => {

                            let newsArticles = response.sort((a, b) => new Date(b.publish_date) - new Date(a.publish_date));
                            let adultData = [];
                            let juniorData = [];
                            let allData = [];

                            for (let value of newsArticles) {
                                let day = new Date(value.publish_date).toLocaleString('default', {day: '2-digit'});
                                let month = new Date(value.publish_date).toLocaleString('default', {month: 'long'});
                                let year = new Date(value.publish_date).getFullYear();
                                value.readableDate = day + ' ' + month + ' ' + year;

                                if (value.section === 'Adults' && value.status === 'Live') {
                                    adultData.push(value);
                                }

                                if (value.section === 'Juniors' && value.status === 'Live') {
                                    juniorData.push(value);
                                }

                                if (value.status === 'Live') {
                                    value.readableDate = day + ' ' + month + ' ' + year;
                                    allData.push(value);
                                }
                            }
                            this.news.adults = adultData;
                            this.news.juniors = juniorData;
                            this.news.all = allData;
                        }
                    )
            }
        }
    }
</script>
